'use client';
import CustomLink from '@/components/CustomLink';
import { GiftsModule } from '@/enums';
import { IStoreLists } from '@/interfaces/store';
import useHeaderStore from '@/store/header';
import { Fragment } from 'react';

const MainNav = ({
  content = [],
  className = '',
  onNavSelection = (navItem: IMegaMenuItem) => {},
  navChild,
  navPanel,
}: {
  content?: IMegaMenuItem[];
  className?: string;
  onNavSelection: (navItem: IMegaMenuItem) => void;
  navChild?: IMegaMenuItem;
  navPanel: boolean;
}) => {
  const setIsExpressEnabled = useHeaderStore((state) => state.setIsExpressEnabled);
  const setSelectedStore = useHeaderStore((state) => state.setSelectedStore);
  const setIsStoreSelected = useHeaderStore((state) => state.setIsStoreSelected);
  return (
    <>
      <div className={className}>
        {content.map((link, index) => (
          <Fragment key={link.SeName + index}>
            {link.Items?.length > 0 ? (
              <>
                {link.ItemType === 'Brand' ? (
                  <span
                    className="a underline-custom whitespace-nowrap"
                    onMouseEnter={() => {
                      onNavSelection(link);
                    }}
                  >
                    {link.Name}
                  </span>
                ) : (
                  <CustomLink
                    prefetch={false}
                    className={`a item-hover whitespace-nowrap text-[1.2rem] transition-all after:transition-all after:duration-[50ms] 2xl:text-xl ${
                      navChild?.SeName != link.SeName && navPanel ? 'text-gray-500' : ''
                    } ${navChild?.SeName == link.SeName && navPanel ? 'hovered' : ''} `}
                    href={`/category/${link.SeName}`}
                    onMouseEnter={() => onNavSelection(link)}
                  >
                    {link.Name}
                  </CustomLink>
                )}
              </>
            ) : (
              <CustomLink
                prefetch={false}
                // NOTE: for gifts, we redirect to specific page (next.config.js) as the flow is different than other categories.
                href={'/category/' + link.SeName}
                onMouseEnter={() => onNavSelection(link)}
                onClick={() => {
                  // NOTE: if the link is for gifts or vouchers, we need to disable the express option otherwise it won't should gift items.
                  if (link.SeName.includes(GiftsModule.gift) || link.SeName.includes(GiftsModule.voucher)) {
                    setIsExpressEnabled(false);
                    setSelectedStore({} as IStoreLists);
                    setIsStoreSelected(false);
                  }
                }}
                className={`item-hover whitespace-nowrap text-[1.2rem] transition-all after:transition-all after:duration-[50ms] 2xl:text-xl ${
                  navChild?.SeName != link.SeName && navPanel ? 'text-gray-500' : ''
                } ${navChild?.SeName == link.SeName && navPanel ? 'hovered' : ''}`}
              >
                {link.Name}
              </CustomLink>
            )}
          </Fragment>
        ))}
      </div>
      <style jsx global>{`
        .item-hover {
          position: relative;
        }
        .item-hover:after {
          content: '';
          display: block;
          position: absolute;
          left: 0px;
          bottom: 0px;
          width: 100%;
          height: 0.125rem;
          background-color: black;
          opacity: 0;
          transform: translateY(10px);
        }

        .item-hover.hovered:after {
          opacity: 1;
          transform: translateY(3px);
        }
      `}</style>
    </>
  );
};

export default MainNav;
